// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1lvtY","large":"styles_large__1_gr9"};